import { render, staticRenderFns } from "./assessStatistics.vue?vue&type=template&id=628fc879&scoped=true&"
import script from "./assessStatistics.vue?vue&type=script&lang=js&"
export * from "./assessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./assessStatistics.vue?vue&type=style&index=0&id=628fc879&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fc879",
  null
  
)

export default component.exports